export function getContrastColor(hex: string) {
  // Normalize the hex input
  const normalizedHex = hex.startsWith("#") ? hex.slice(1) : hex;
  // Convert 3-digit hex to 6-digits
  const fullHex =
    normalizedHex.length === 3
      ? normalizedHex
          .split("")
          .map((x) => x + x)
          .join("")
      : normalizedHex;

  if (fullHex.length !== 6) {
    return "";
  }

  // Convert to RGB
  const r = parseInt(fullHex.slice(0, 2), 16);
  const g = parseInt(fullHex.slice(2, 4), 16);
  const b = parseInt(fullHex.slice(4, 6), 16);

  // Calculate luminance per ITU-R BT.709
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? "#000" : "#fff";
}
